export default __webpack_public_path__ + "static/media/bookparking.be4a982d.png";